import { useState, useEffect } from "react";

const TOTAL_SECONDS = 60;

const GeneratingCountdown = () => {
  const [elapsed, setElapsed] = useState(0);
  const remaining = Math.max(0, TOTAL_SECONDS - elapsed);
  const progress = Math.min(elapsed / TOTAL_SECONDS, 1);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsed((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const radius = 52;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - progress);

  return (
    <div className="flex flex-col items-center gap-5 rounded-xl border bg-card p-10 text-center animate-fade-in">
      {/* Circular countdown */}
      <div className="relative h-32 w-32">
        <svg className="h-full w-full -rotate-90" viewBox="0 0 120 120">
          <circle
            cx="60" cy="60" r={radius}
            fill="none"
            className="stroke-muted"
            strokeWidth="6"
          />
          <circle
            cx="60" cy="60" r={radius}
            fill="none"
            className="stroke-primary transition-all duration-1000 ease-linear"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-bold font-display text-foreground tabular-nums">
            {remaining}
          </span>
          <span className="text-xs text-muted-foreground">seconds</span>
        </div>
      </div>

      {/* Status messages */}
      <div className="space-y-1">
        <p className="text-sm font-semibold text-foreground">
          {elapsed < 10
            ? "Uploading your selfie…"
            : elapsed < 30
              ? "Creating your avatar…"
              : elapsed < 50
                ? "Adding finishing touches…"
                : "Almost there…"}
        </p>
        <p className="text-xs text-muted-foreground">
          Your unique avatar is being crafted by AI
        </p>
      </div>

      {/* Pulsing dots */}
      <div className="flex gap-1.5">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-2 w-2 rounded-full bg-primary"
            style={{
              animation: `pulse 1.4s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default GeneratingCountdown;
